import { render, staticRenderFns } from "./MilestonesListItem.vue?vue&type=template&id=40a402a6&scoped=true&"
import script from "./MilestonesListItem.vue?vue&type=script&lang=js&"
export * from "./MilestonesListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a402a6",
  null
  
)

export default component.exports